import {
  SET_REVIEWS,
  RESET_REVIEWS,
  SET_SPECIFIC_REVIEW,
  RESET_SPECIFIC_REVIEW,
  SET_REVIEW_LOADING,
  RESET_REVIEW_LOADING,
} from "../Types/ReviewsTypes";

const initialState = {
  reviews: [],
  specificReview: null,
  loading: false,
};

const ReviewsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_REVIEWS:
      return {
        ...state,
        reviews: action.payLoad,
      };

    case RESET_REVIEWS:
      return {
        ...state,
        reviews: [],
      };

    case SET_SPECIFIC_REVIEW:
      return {
        ...state,
        specificReview: action.payLoad,
      };

    case RESET_SPECIFIC_REVIEW:
      return {
        ...state,
        specificReview: null,
      };

    case SET_REVIEW_LOADING:
      return {
        ...state,
        loading: true,
      };

    case RESET_REVIEW_LOADING:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
};

export default ReviewsReducer;